import Vue from 'vue'
import Router from 'vue-router'
import AigcLayout from '@/views/aigc/AigcLayout'
import AigcHome from '@/views/aigc/AigcHome'
import AigcCreate from '@/views/aigc/AigcCreate'
import AigcLogin from '@/views/aigc/AigcLogin'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
		{
		  path: '/',
		  name: 'index',
		  component: () => import('@/views/index/index'),
		},
		{
		  path: '/aigc/login',
		  name: 'aigc_login',
		  component: AigcLogin,
		},
		/** 真人素材人像授权（独立页：入口 + H5 跳转 + 上传资产） */
		{
		  path: '/aigc/real-human-liveness',
		  name: 'aigc_real_human_liveness',
		  meta: { requireAuth: true },
		  component: () => import('@/views/aigc/RealHumanLivenessAuth'),
		},
		{
		  path: '/aigc',
		  component: AigcLayout,
		  redirect: '/aigc/create',
		  children: [
		    {
		      path: 'home',
		      name: 'aigc_home',
		      component: AigcHome,
		    },
		    {
		      path: 'create',
		      name: 'aigc_create',
		      component: AigcCreate,
		    },
		  ],
		},
		{
		  path: '/login',
		  name: 'login',
		  component: () => import('@/views/login/login'),
		},
		{
		  path: '/register',
		  name: 'register',
		  component: () => import('@/views/register/register'),
		},
		{
		  path: '/agreement',
		  name: 'agreement',
		  component: () => import('@/views/register/agreement'),
		},
		{
		  path: '/get_password',
		  name: 'get_password',
		  component: () => import('@/views/get_password/get_password'),
		},
		{
		  path: '/cloud_service_buy',
		  name: 'cloud_service_buy',
		  component: () => import('@/views/cloud_service/buy'),
		},
		{
		  path: '/eip_buy',
		  name: 'eip_buy',
		  component: () => import('@/views/eip/buy'),
		},
		{
		  path: '/tokens',
		  name: 'tokens',
		  component: () => import('@/views/tokens/index'),
		},
		{
		  path: '/rds_buy',
		  name: 'rds_buy',
		  component: () => import('@/views/rds/buy'),
		},

		// 常见问题
		{
		    path: '/question',
		    name: 'question',
		    component: () =>
		        import ('@/views/question/question')
		},
		{
		    path: '/question_detail',
		    name: 'question_detail',
		    component: () =>
		        import ('@/views/question/question_detail')
		},
		// 帮助文档
		{
		    path: '/help',
		    name: 'help',
		    component: () =>
		        import ('@/views/overview/help')
		},
		{
		    path: '/help_detail',
		    name: 'help_detail',
		    component: () =>
		        import ('@/views/overview/help_detail')
		},
		// 618
		{
		    path: '/activity',
		    name: 'activity',
		    component: () =>
		        import ('@/views/promotions/activity')
		},
		// 聚合支付
		{
		    path: '/unifyPay',
		    name: 'unifyPay',
		    component: () =>
		        import ('@/views/unifyPay/unifyPay')
		},
		{
		    path: '/unifyPay_confirm',
		    name: 'unifyPay_confirm',
		    component: () =>
		        import ('@/views/unifyPay/confirm')
		},
		{
        path: '/home',
		meta: {requireAuth: true},
        component: () =>
            import ('@/views/home'),
        children: [{
                path: '/overview',
                name: 'overview',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/overview/overview')
            },
            {
                path: '/message',
                name: 'message',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/overview/message')
            },
            {
                path: '/message_detail',
                name: 'message_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/overview/message_detail')
            },

            //instance
            {
                path: '/instances',
                name: 'instances',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/instance/instances')
            },
            {
                path: '/instance_detail',
                name: 'instance_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/instance/instance_detail')
            },
            {
                path: '/instance_updown',
                name: 'instance_updown',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/instance/instance_updown')
            },
            {
                path: '/instance_updown_tencent',
                name: 'instance_updown_tencent',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/instance/instance_updown_tencent')
            },
            {
                path: '/instance_recycle',
                name: 'instance_recycle',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/instance/instance_recycle')
            },
            {
                path: '/security_group',
                name: 'security_group',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/instance/security_group')
            },
            //domain
            {
                path: '/domain_list',
                name: 'domain_list',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/domain_list')
            },
            {
                path: '/domain_detail',
                name: 'domain_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/domain_detail')
            },
            {
                path: '/detail_edit',
                name: 'detail_edit',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/detail_edit')
            },
            {
                path: '/parsing_dns',
                name: 'parsing_dns',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/parsing_dns')
            },
            {
                path: '/domain_renewal',
                name: 'domain_renewal',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/domain_renewal')
            },
            {
                path: '/info_tempList',
                name: 'info_tempList',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/info_tempList')
            },
            {
                path: '/add_temp',
                name: 'add_temp',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/add_temp')
            },
            {
                path: '/info_certification',
                name: 'info_certification',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/info_certification')
            },
            {
                path: '/temp_detail',
                name: 'temp_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/temp_detail')
            },
            {
                path: '/domain_agreement',
                name: 'domain_agreement',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/agreement')
            },
            {
                path: '/domain_protect',
                name: 'domain_protect',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/protect')
            },
            {
                path: '/domain_search',
                name: 'domain_search',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/search')
            },
            {
                path: '/domain_orderPay',
                name: 'domain_orderPay',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/orderPay')
            },
            {
                path: '/domain_priceList',
                name: 'domain_priceList',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/priceList')
            },
            {
                path: '/domain_flowChart',
                name: 'domain_flowChart',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/flowChart')
            },
            {
                path: '/domain_rollIn',
                name: 'domain_rollIn',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/rollIn')
            },
            {
                path: '/domain_details',
                name: 'domain_details',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/domain/details')
            },
            //finance
            {
                path: '/recharge',
                name: 'recharge',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/recharge')
            },
          // 手机微信支付中转页
          {
              path: '/weixin_wap',
              name: 'weixin_wap',
              meta: {requireAuth: true},
              component: () =>
                  import ('@/views/finance/weixin_wap')
          },
            {
                path: '/amount_detail',
                name: 'amount_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/amount_detail')
            },
            {
                path: '/amount_list_detail',
                name: 'amount_list_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/amount_list_detail')
            },
            {
                path: '/cash',
                name: 'cash',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/cash')
            },
            {
                path: '/buyOrder',
                name: 'buyOrder',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/buyOrder')
            },
            {
                path: '/buyOrder_detail',
                name: 'buyOrder_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/buyOrder_detail')
            },
            {
                path: '/contract',
                name: 'contract',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/contract')
            },
            {
                path: '/contract_apply',
                name: 'contract_apply',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/contract_apply')
            },
            {
                path: '/invoice',
                name: 'invoice',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/invoice')
            },
            {
                path: '/invoice_create',
                name: 'invoice_create',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/invoice_create')
            },
            {
                path: '/address_create',
                name: 'address_create',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/address_create')
            },
            {
                path: '/distributor_address_create',
                name: 'distributor_address_create',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/address_create')
            },
            {
                path: '/invoice_apply',
                name: 'invoice_apply',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/invoice_apply')
            },
            {
                path: '/invoice_detail',
                name: 'invoice_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/invoice_detail')
            },
            {
                path: '/coupon',
                name: 'coupon',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/coupon')
            },
			{
			    path: '/coupon_center',
			    name: 'coupon_center',
			    component: () =>
			        import ('@/views/finance/coupon_center')
			},
      {
              path: '/advance',
              name: 'advance',
      meta: {requireAuth: true},
              component: () =>
                  import ('@/views/finance/advance')
          },
          {
                  path: '/advanceList',
                  name: 'advanceList',
          meta: {requireAuth: true},
                  component: () =>
                      import ('@/views/finance/advanceList')
              },
              {
                      path: '/subAdvanceList',
                      name: 'subAdvanceList',
              meta: {requireAuth: true},
                      component: () =>
                          import ('@/views/finance/subAdvanceList')
                  },
                  {
                          path: '/accountList',
                          name: 'accountList',
                  meta: {requireAuth: true},
                          component: () =>
                              import ('@/views/finance/accountList')
                      },
            {
                path: '/refund',
                name: 'refund',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/refund')
            },
            {
                path: '/refund_apply',
                name: 'refund_apply',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/refund_apply')
            },
            {
                path: '/refund_detail',
                name: 'refund_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/finance/refund_detail')
            },
            //renew
            {
                path: '/renew_list',
                name: 'renew_list',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/renew/renew_list')
            },
            {
                path: '/renew_eip_list',
                name: 'renew_eip_list',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/renew/renew_eip_list')
            },
            //renew
            {
                path: '/renew_rds_list',
                name: 'renew_rds_list',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/renew/renew_rds_list')
            },
            //order
            {
                path: '/my_order',
                name: 'my_order',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/order/my_order')
            },
            {
                path: '/order_detail',
                name: 'order_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/order/order_detail')
            },
            {
                path: '/order_score',
                name: 'order_score',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/order/order_score')
            },
            {
                path: '/order_complaint',
                name: 'order_complaint',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/order/order_complaint')
            },
            {
                path: '/order_class',
                name: 'order_class',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/order/order_class')
            },
            {
                path: '/order_form',
                name: 'order_form',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/order/order_form')
            },
            //setting
            {
                path: '/my',
                name: 'my',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/my')
            },
            {
                path: '/security',
                name: 'security',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/security')
            },
            {
                path: '/edit_qq',
                name: 'edit_qq',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/edit_qq')
            },
            {
                path: '/certification',
                name: 'certification',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/certification')
            },
            {
                path: '/comoany_certification',
                name: 'comoany_certification',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/comoany_certification')
            },
            {
                path: '/password',
                name: 'password',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/password')
            },
            {
                path: '/edit_mobile',
                name: 'edit_mobile',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/edit_mobile')
            },
            {
                path: '/email',
                name: 'email',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/email')
            },
            {
                path: '/security_question',
                name: 'security_question',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/security_question')
            },
            {
                path: '/address',
                name: 'address',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/setting/address')
            },
            // 渠道商
            {
                path: '/invite',
                name: 'invite',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/invite')
            },
            {
                path: '/dis_center',
                name: 'dis_center',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/dis_center')
            },
            {
                path: '/distributor_synopsis',
                name: 'distributor_synopsis',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/synopsis')
            },
            {
                path: '/distributor_client_manage',
                name: 'distributor_client_manage',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/client_manage')
            },
            {
                path: '/distributor_client_detail',
                name: 'distributor_client_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/client_detail')
            },
            {
                path: '/distributor_client_order',
                name: 'distributor_client_order',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/client_order')
            },
            {
                path: '/distributor_client_order_detail',
                name: 'distributor_client_order_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/client_order_detail')
            },
            {
                path: '/distributor_client_assign',
                name: 'distributor_client_assign',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/client_assign')
            },
            {
                path: '/distributor_invoice',
                name: 'distributor_invoice',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/invoice')
            },
            {
                path: '/distributor_invoice_apply',
                name: 'distributor_invoice',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/invoice_apply')
            },
            {
                path: '/distributor_invoice_create',
                name: 'distributor_invoice_create',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/invoice_create')
            },
            {
                path: '/distributor_invoice_detail',
                name: 'distributor_invoice_detail',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/invoice_detail')
            },
            {
                path: '/distributor_commission',
                name: 'distributor_commission',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/commission')
            },
            {
                path: '/distributor_member',
                name: 'distributor_member',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/views/distributor/member')
            },
            // 404
            {
                path: '/404',
                name: '404',
				meta: {requireAuth: true},
                component: () =>
                    import ('@/404')
            },
			// 弹性公网IP
			{
			    path: '/eip_list',
			    name: 'eip_list',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/eip/eip_list')
			},
			// 弹性公网IP
			{
			    path: '/tag_list',
			    name: 'tag_list',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/instance/tag_list')
			},
			// 云数据库
			{
			    path: '/rds_center',
			    name: 'rds_center',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_center')
			},
			{
			    path: '/rds_list',
			    name: 'rds_list',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_list')
			},
			// 云数据库（回收站）
			{
			    path: '/rds_instance_recycle',
			    name: 'rds_instance_recycle',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_instance_recycle')
			},
			// 云数据库（基本信息）
			{
			    path: '/rds_basic_info',
			    name: 'rds_basic_info',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_basic_info')
			},
			// 云数据库（账号管理）
			{
			    path: '/rds_account_manage',
			    name: 'rds_account_manage',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_account_manage')
			},
			// 云数据库（数据库管理）
			{
			    path: '/rds_manage',
			    name: 'rds_manage',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_manage')
			},
			// 云数据库（白名单）
			{
			    path: '/rds_white_list',
			    name: 'rds_white_list',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_white_list')
			},
			// 云数据库（数据备份）
			{
			    path: '/rds_backup',
			    name: 'rds_backup',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_backup')
			},
			// 云数据库（参数设置）
			{
			    path: '/rds_param_setting',
			    name: 'rds_param_setting',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_param_setting')
			},
			// 云数据库（日志管理）
			{
			    path: '/rds_log',
			    name: 'rds_log',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_log')
			},
			// 云数据库（备份设置）
			{
			    path: '/rds_backup_setting',
			    name: 'rds_backup_setting',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_backup_setting')
			},
			// 云数据库（白名单修改）
			{
			    path: '/rds_white_edit',
			    name: 'rds_white_edit',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_white_edit')
			},
			// 云数据库（升级降配）
			{
			    path: '/rds_updown',
			    name: 'rds_updown',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_updown')
			},
			// 云数据库（创建账号）
			{
			    path: '/rds_account_create',
			    name: 'rds_account_create',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_account_create')
			},
			// 云数据库（创建数据库）
			{
			    path: '/rds_manage_create',
			    name: 'rds_manage_create',
				meta: {requireAuth: true},
			    component: () =>
			        import ('@/views/rds/rds_manage_create')
			},
			// 云数据库（数据统计）
			{
			    path: '/rds_monitor',
			    name: 'rds_monitor',
			    component: () =>
			        import ('@/views/rds/rds_monitor')
			},
      // 负载均衡
      {
          path: '/slb_list',
          name: 'slb_list',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/slb_list')
      },
      // 负载均衡——升级
      {
          path: '/slb_updown',
          name: 'slb_updown',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/slb_updown')
      },
      // 负载均衡——安全组
      {
          path: '/slb_sg',
          name: 'slb_sg',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/slb_sg')
      },
      // 负载均衡——管理
      {
          path: '/slb_detail',
          name: 'slb_detail',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/slb_detail')
      },
      // 负载均衡——回收站
      {
          path: '/slb_recycle',
          name: 'slb_recycle',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/slb_recycle')
      },
      // 负载均衡——证书管理
      {
          path: '/certificate_list',
          name: 'certificate_list',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/certificate_list')
      },
      // 负载均衡——新建
      {
          path: '/slb_buy',
          name: 'slb_buy',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/slb/buy')
      },
      // 续费管理——负载均衡
      {
          path: '/renew_slb_list',
          name: 'renew_slb_list',
      	meta: {requireAuth: true},
          component: () =>
              import ('@/views/renew/renew_slb_list')
      },
        ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js